import React from "react";
import ResetPassword from "./resetPassword/containers/ResetPassword";
import {Router, Route, browserHistory} from 'react-router';
import {syncHistoryWithStore} from 'react-router-redux';
import {configureStore, application, fwUrlUtils} from "assecobs-faktor-web-common/index"
import rootReducer from "./resetPassword/reducers/index";
import {Error404} from "assecobs-faktor-web-common";
import "assecobs-faktor-web-profile-styles/main.scss";

(async function () {
    const render = await application(false, false);
    const store = await configureStore(rootReducer);
    const history = syncHistoryWithStore(browserHistory, store);

    const content = () => (
        <Router history={history}>
            <Route path={fwUrlUtils.getContextUrl("/resetPassword")} component={ResetPassword}/>
            <Route path={fwUrlUtils.getContextUrl("/*")} component={Error404}/>
        </Router>
    );

    render(content, store);
}());

